import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const BOABuyerViewPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./BOABuyerViewPage')).BOABuyerViewPage,
  }))
);

export const BuyerOfferAnalysisPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./BuyerOfferAnalysisPage')).BuyerOfferAnalysisPage,
  }))
);
